import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00eda09a")

_pushScopeId("data-v-00eda09a")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_promotion",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "text-gray-600 fs-6 mb-8" }
const _hoisted_8 = { class: "fv-row mb-5" }
const _hoisted_9 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_10 = { class: "required" }
const _hoisted_11 = { class: "fv-row mb-5" }
const _hoisted_12 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_13 = { class: "required" }
const _hoisted_14 = {
  key: 1,
  class: "fv-row mb-5"
}
const _hoisted_15 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_16 = { class: "required" }
const _hoisted_17 = {
  key: 0,
  class: "upload-image-col"
}
const _hoisted_18 = { class: "upload-image-box" }
const _hoisted_19 = { class: "upload-box" }
const _hoisted_20 = { class: "add-image" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-camera-retro" })
], -1)
const _hoisted_22 = {
  key: 1,
  class: "col-md-4 px-0"
}
const _hoisted_23 = { class: "hover-effect" }
const _hoisted_24 = { class: "image-heading" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_26 = { class: "fv-row mb-5" }
const _hoisted_27 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_28 = {
  key: 2,
  class: "row"
}
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_31 = { class: "required" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_34 = { class: "required" }
const _hoisted_35 = { class: "d-flex flex-stack" }
const _hoisted_36 = { class: "me-5" }
const _hoisted_37 = { class: "fs-5 fw-bold" }
const _hoisted_38 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_39 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_40 = { class: "modal-footer flex-center" }
const _hoisted_41 = {
  type: "button",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_42 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Image = _resolveComponent("Image")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "promotionForm",
          model: _ctx.formData
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(_ctx.formData.id ? _ctx.$t('message.EDIT') : _ctx.$t('message.ADD')) + " " + _toDisplayString(_ctx.formData.type === 'SERVICE' ? _ctx.$t('message.SERVICE_PROMOTION') : _ctx.$t('message.PRODUCT_PROMOTION')), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('message.SEND_TO')) + ": " + _toDisplayString(_ctx.$t('message.ALL_CUSTOMERS')) + ", " + _toDisplayString(_ctx.$t('message.SPECIFIC_CUSTOMERS')) + ", " + _toDisplayString(_ctx.$t('message.CUSTOMER_GROUPS')) + ". ", 1),
              (_ctx.formData.type === 'SERVICE')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("label", _hoisted_9, [
                        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('message.TITLE')), 1)
                      ]),
                      _createVNode(_component_el_form_item, {
                        prop: "title",
                        rules: _ctx.textRules
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.title,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.title = $event)),
                            type: "text",
                            placeholder: _ctx.$t('message.TITLE')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("label", _hoisted_12, [
                        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('message.PROMOTION_MESSAGE')), 1)
                      ]),
                      _createVNode(_component_el_form_item, {
                        prop: "message",
                        rules: _ctx.textRules
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.message,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.message = $event)),
                            type: "textarea",
                            rows: 4,
                            placeholder: _ctx.$t('message.PROMOTION_MESSAGE')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.formData.type !== 'SERVICE')
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("label", _hoisted_15, [
                      _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.IMAGE')), 1)
                    ]),
                    (_ctx.previewImage.length == 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("div", _hoisted_19, [
                              _createVNode("div", _hoisted_20, [
                                _createVNode("input", {
                                  type: "file",
                                  class: "upload-btn",
                                  accept: "image/png, image/jpg, image/jpeg, image/gif, image/webp",
                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
                                }, null, 32),
                                _hoisted_21,
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('message.UPLOAD_IMAGES')), 1),
                                _createVNode("span", null, "JPG, GIF " + _toDisplayString(_ctx.$t('message.OR')) + " PNG " + _toDisplayString(_ctx.$t('message.FORMAT')), 1)
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_22, [
                          _createVNode("div", _hoisted_23, [
                            _createVNode("img", {
                              src: _ctx.previewImage[0].src,
                              alt: "",
                              class: "image-thumbnail"
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_24, [
                              _createVNode("i", {
                                class: "fas fa-search",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showMedia(0)))
                              }),
                              _hoisted_25,
                              _createVNode("i", {
                                class: "fas fa-trash-alt",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeMedia(0, _ctx.previewImage[0].id)))
                              })
                            ])
                          ])
                        ])),
                    _createVNode(_component_Image)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_26, [
                _createVNode("label", _hoisted_27, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('message.URL')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  prop: "url",
                  class: "url-item"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.url,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.url = $event)),
                      type: "text",
                      placeholder: "https://"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              (_ctx.formData.type !== 'SERVICE')
                ? (_openBlock(), _createBlock("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("label", _hoisted_30, [
                        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('message.START_DATE')), 1)
                      ]),
                      _createVNode(_component_el_form_item, {
                        prop: "starts_at",
                        rules: _ctx.dateRules,
                        class: "date-item"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.starts_at,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.starts_at = $event)),
                            type: "date",
                            format: "DD-MM-YYYY",
                            "value-format": "YYYY-MM-DD",
                            "disabled-date": _ctx.disabledDate,
                            "popper-class": "promotion-date-picker",
                            placeholder: _ctx.$t('message.START_DATE')
                          }, null, 8, ["modelValue", "disabled-date", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("label", _hoisted_33, [
                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('message.END_DATE')), 1)
                      ]),
                      _createVNode(_component_el_form_item, {
                        prop: "ends_at",
                        rules: _ctx.dateRules,
                        class: "date-item"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.ends_at,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.ends_at = $event)),
                            type: "date",
                            format: "DD-MM-YYYY",
                            "value-format": "YYYY-MM-DD",
                            "disabled-date": _ctx.disabledEndDate,
                            "popper-class": "promotion-date-picker",
                            placeholder: _ctx.$t('message.END_DATE')
                          }, null, 8, ["modelValue", "disabled-date", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Select, {
                name: "audience_type",
                target: "audience_type",
                label: _ctx.$t('message.SEND_TO'),
                callEmit: true,
                required: true,
                clearable: false,
                audience_type: _ctx.formData.audience_type,
                "onUpdate:audience_type": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.audience_type = $event)),
                selectData: _ctx.audienceOptions,
                value: _ctx.formData.audience_type,
                onChange: _ctx.onAudienceChange
              }, null, 8, ["label", "audience_type", "selectData", "value", "onChange"]),
              _createVNode(_component_Select, {
                name: "customer_ids",
                target: "customer_ids",
                label: _ctx.$t('message.CUSTOMERS'),
                placeholder: _ctx.$t('message.SELECT_CUSTOMERS'),
                multiple: true,
                filterable: true,
                clearable: true,
                required: _ctx.formData.audience_type === 'CUSTOMERS',
                disabled: _ctx.formData.audience_type !== 'CUSTOMERS',
                customer_ids: _ctx.formData.customer_ids,
                "onUpdate:customer_ids": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.customer_ids = $event)),
                selectData: _ctx.customers,
                value: _ctx.formData.customer_ids
              }, null, 8, ["label", "placeholder", "required", "disabled", "customer_ids", "selectData", "value"]),
              _createVNode(_component_Select, {
                name: "customer_group_ids",
                target: "customer_group_ids",
                label: _ctx.$t('message.CUSTOMER_GROUPS'),
                placeholder: _ctx.$t('message.SELECT_CUSTOMER_GROUPS'),
                multiple: true,
                filterable: true,
                clearable: true,
                required: _ctx.formData.audience_type === 'CUSTOMER_GROUPS',
                disabled: _ctx.formData.audience_type !== 'CUSTOMER_GROUPS',
                customer_group_ids: _ctx.formData.customer_group_ids,
                "onUpdate:customer_group_ids": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.customer_group_ids = $event)),
                selectData: _ctx.customerGroups,
                value: _ctx.formData.customer_group_ids
              }, null, 8, ["label", "placeholder", "required", "disabled", "customer_group_ids", "selectData", "value"]),
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('message.STATUS')), 1),
                  _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('message.PROMOTION')) + " " + _toDisplayString(_ctx.$t('message.ACTIVATE_AND_DEACTIVATE')), 1)
                ]),
                _createVNode("span", _hoisted_39, [
                  _createVNode(_component_el_switch, {
                    class: "status-switch",
                    modelValue: _ctx.formData.status,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.status = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_40, [
              _createVNode("button", _hoisted_41, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
              }, [
                _createVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
})